import type { AppStrings } from './types.js';

export const zhHant: AppStrings = {
  // COMMON
  error_title: '發生錯誤',
  cancel: '取消',
  retry: '重試',
  back_arrow: '← 返回',

  // ASK SCREEN
  ask_box_unavailable: '問題箱無法使用',
  ask_box_unavailable_desc: '連結可能已過期，或對方已關閉問題箱。',
  ask_create_own_box: '建立我的問題箱',
  ask_sent_title: '已送出 ✅',
  ask_sent_desc: '你的匿名問題已送達對方。',
  ask_anonymous_hint: '問題將以匿名方式送出。',
  ask_placeholder: '寫下你的問題…',
  ask_send: '送出',
  ask_sending: '送出中…',
  ask_error_rate_limit: '操作太頻繁，請等一分鐘再試。',
  ask_error_restart: '請重新啟動 Mini App。',
  ask_error_load: '問題箱載入失敗。',
  ask_error_send: '問題送出失敗。',
  ask_error_banned: '你已在應用程式中被封鎖。',
  ask_banned_appeal_btn: '申訴',
  ask_appeal_sent: '申訴已送出，我們將進行人工審查。',

  // AGE GATE
  age_gate_title: '僅限 18 歲以上',
  age_gate_desc:
    '你正在送出匿名問題。請保持尊重：禁止騷擾、威脅、涉及未成年人的色情內容及任何違法內容。匿名不代表免責——違規行為將回報審核。送出問題即表示你已年滿 18 歲並同意規則。',
  age_gate_confirm: '我已滿 18 歲，繼續',

  // INBOX SCREEN
  inbox_title: '我的問題箱',
  box_link_accordion: '邀請連結',
  inbox_notifications_ask: '🔔 允許機器人推播新問題通知嗎？',
  inbox_notifications_allow: '允許',
  inbox_notifications_dismiss_label: '關閉',
  inbox_box_toggle_disable: '關閉問題箱',
  inbox_box_toggle_enable: '開啟問題箱',
  inbox_box_disabled_warning: '問題箱已關閉，暫不接受新問題。',
  inbox_share_hint: '分享連結，讓朋友匿名向你提問。',
  inbox_copy: '複製',
  inbox_copied: '已複製',
  inbox_copy_error: '發生錯誤',
  inbox_no_deeplink: '連結將在部署後出現。',
  inbox_invite_story: '透過 Story 邀請',
  inbox_invite_chat: '透過聊天邀請',
  inbox_card_rendering: '邀請卡片產生中。',
  inbox_story_unsupported: '此版本 Telegram 不支援 Story，請改用「透過聊天」。',
  inbox_story_error: '無法開啟 Story。',
  inbox_chat_unsupported: '此版本 Telegram 不支援分享至聊天，請更新用戶端。',
  inbox_chat_error: '分享失敗，請重試。',
  inbox_chat_prepare_error: '邀請內容準備失敗。',
  inbox_filter_incoming: '收到的',
  inbox_filter_hidden: '已隱藏',
  inbox_filter_blocked: '已封鎖',
  inbox_filter_empty: '這裡還沒有內容。',
  inbox_acc_unanswered: '未回答',
  inbox_acc_answered: '已回答',
  inbox_acc_hidden: '已隱藏',
  inbox_acc_blocked: '已封鎖',
  inbox_empty: '還沒有問題。分享上方連結吧。',
  inbox_load_more: '載入更多',
  inbox_load_more_error: '下一頁載入失敗。',
  inbox_error_load: '問題箱載入失敗。',
  inbox_rate_limit: '操作太頻繁，請等一分鐘再試。',
  inbox_toggle_error: '問題箱狀態更新失敗。',

  // MESSAGE BOX (Трек D)
  message_tagline: '匿名給我留言',
  message_placeholder: '寫下留言…',
  message_anonymous_hint: '留言將以匿名方式送出。',
  message_sent_title: '已送出 ✅',
  message_sent_desc: '你的匿名留言已送達。',
  message_owner_entry: '給我留言',
  message_share_hint: '分享連結，讓任何人都能給你發匿名留言。',
  message_inbox_open: '收到的留言',
  message_inbox_title: '留言',
  message_inbox_empty: '還沒有留言。分享上方連結吧。',

  // ANSWER SCREEN
  answer_title: '回答問題',
  answer_placeholder: '寫下你的回答…',
  answer_submit: '送出',
  answer_submitting: '送出中…',
  answer_back: '返回',
  answer_error_send: '回答送出失敗。',

  // SHARE SCREEN
  share_title: '回答已發布 ✅',
  share_hint: '分享卡片，收集更多問題。',
  share_card_rendering_desc:
    '卡片還在產生中。回到問題列表稍後再來——就能在 Story 或聊天中分享了。',
  share_card_alt: '回答卡片',
  share_story_btn: '分享至 Story',
  share_story_btn_busy: '開啟中…',
  share_chat_btn: '分享至聊天',
  share_chat_btn_busy: '準備中…',
  share_back: '回到問題',
  share_story_unsupported: '此版本 Telegram 不支援 Story，請改用「分享至聊天」。',
  share_story_error: '無法開啟 Story，請改用「分享至聊天」。',
  share_chat_sent: '訊息已送出。',
  share_chat_unsupported: '此版本 Telegram 不支援分享至聊天，請更新用戶端。',
  share_chat_error: '分享失敗，請重試。',
  share_chat_prepare_error: '訊息準備失敗。',

  // LEADERBOARD SCREEN
  lb_title: '排行榜',
  lb_period_7d: '7 天',
  lb_period_30d: '30 天',
  lb_period_all: '所有時間',
  lb_group_label: '分類',
  lb_group_all: '全部',
  lb_group_ask: '提問',
  lb_group_rate: '評分',
  lb_group_confession: '告白',
  lb_group_guesswho: '猜猜我是誰',
  lb_group_message: '留言',
  lb_error: '排行榜載入失敗',
  lb_empty: '還沒有人上榜',
  lb_anon: '匿名',
  lb_load_more: '載入更多',
  lb_questions: (n) => `${n} 個問題`,
  lb_referrals: (n) => `${n} 次邀請`,

  // REWARDS SCREEN
  rw_title: '我的獎勵',
  rw_error: '獎勵載入失敗',
  rw_level: (n) => `第 ${n} 級`,
  rw_confirmed_referrals: (n) => `${n} 位已確認好友`,
  rw_next_level_section: (n) => `下一級 — 需邀請 ${n} 位`,
  rw_to_level: (level, target) => `距第 ${level} 級：還需 ${target}`,
  rw_max_level: '已達到最高等級！',
  rw_badges_section: '徽章',
  rw_formats_section: '問題箱樣式',

  // QUESTION CARD
  qcard_status_new: '新',
  qcard_status_hidden: '已隱藏',
  qcard_status_answered: '已回答',
  qcard_moderation_flagged: '注意：可疑訊息',
  qcard_answer_btn: '回答',
  qcard_answer_send: '送出',
  qcard_share_btn: '分享',
  qcard_hide_btn: '隱藏',
  qcard_show_btn: '顯示',
  qcard_report_btn: '檢舉',
  qcard_block_btn: '封鎖',
  qcard_unblock_btn: '解除封鎖',
  qcard_report_reason_label: '選擇檢舉原因：',
  qcard_reason_spam: '垃圾訊息',
  qcard_reason_harassment: '騷擾',
  qcard_reason_sexual: '色情內容',
  qcard_reason_other: '其他',
  qcard_error_hide: '可見性變更失敗。',
  qcard_error_report: '檢舉送出失敗。',
  qcard_error_block: '封鎖發送者失敗。',
  qcard_report_done: '檢舉已送出，謝謝。',
  qcard_block_done: '發送者已封鎖。',
  qcard_unblock_done: '已解除封鎖。',

  // ERRORS
  err_network: '無法連線至伺服器，請確認網路後重試。',
  err_server_unavailable: '伺服器暫時無法使用，請稍後再試。',
  err_internal: '發生了一點小問題，我們正在處理——請稍後再試。',
  err_bad_request: '請確認輸入的內容。',
  err_generic: '操作未完成，請稍後再試。',
  err_schema: '資料異常，請嘗試更新應用程式。',
  share_story_link_premium_note:
    'Story 中的可點擊連結需要 Telegram Premium。沒有 Premium 也沒關係——你的用戶名已顯示在卡片上。',

  // AUTH ERROR SCREEN
  auth_error_title: '存取錯誤',
  auth_error_desc: '登入失敗。請從 Telegram 中關閉並重新開啟 Mini App。',

  // REWARD TOAST
  reward_toast_title: '新獎勵！',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: '問題',
  tab_leaderboard: '排行榜',
  tab_rewards: '獎勵',
  tab_settings: '設定',

  // SETTINGS SCREEN
  settings_title: '設定',
  settings_section_general: '一般',
  settings_notifications: '新問題通知',
  settings_notifications_hint: '有人提問時，機器人會傳訊息給你。',
  settings_notifications_error: '通知設定儲存失敗。',
  settings_language: '語言',
  settings_language_error: '語言切換失敗，請重試。',
  settings_section_about: '關於',
  settings_version: '版本',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story 連結僅限 Premium',
  code_modal_explain:
    'Telegram 僅向 Premium 用戶提供可點擊的 Story 連結。你可以在 Story 中寫上你的代碼——觀眾在應用程式裡輸入代碼就能匿名向你提問。',
  code_modal_your_code: '你的代碼',
  code_modal_copy: '複製代碼',
  code_modal_copied: '已複製',
  code_modal_share_btn: '分享至 Story',
  code_modal_loading: '取得代碼中…',
  code_modal_error: '取得代碼失敗，請稍後再試。',
  ask_code_title: '輸入代碼',
  ask_code_desc: '從 Story 來的？找到其中的代碼（例如 1234）並在下方輸入。',
  ask_code_placeholder: 'Story 中的代碼',
  ask_code_find: '搜尋',
  ask_code_not_found: '找不到該代碼，請確認數字後重試。',
  ask_code_invalid: '代碼為 4 位數字。',
  code_onboarding_header: '從 Story 來的？',
  code_onboarding_text: '輸入朋友的代碼，向他匿名提問。',
  code_onboarding_action: '輸入代碼',
  settings_ask_by_code: '透過代碼提問',
  settings_my_code_title: '你的 Story 代碼',
  settings_my_code_hint:
    '把這個代碼寫進 Story——觀眾輸入後就能匿名向你提問。Telegram 僅向 Premium 用戶提供可點擊連結。',
  settings_my_code_rotate: '取得新代碼',
  settings_my_code_rotating: '更新中…',
  settings_my_code_done: '代碼已更新',
  settings_my_code_error: '取得代碼失敗。',
  settings_my_code_rotate_confirm_title: '要更換代碼嗎？',
  settings_my_code_rotate_confirm_desc:
    '舊代碼會立刻失效，之前在你 Story 看到它的人就再也聯絡不到你了。除非有人一直騷擾你，否則別更換。',
  settings_my_code_rotate_confirm_action: '更換代碼',

  // BOT
  bot_greeting: (name) => (name ? `你好，${name}！👋` : '你好！👋'),
  bot_onboarding:
    '這是 VeylMe — 匿名提問。\n\n' +
    '打開 Mini App，在你的 Story 發布「匿名問我」卡片 — ' +
    '匿名問題就會直接發到這裡。\n\n' +
    '⚠️ 18+。請文明互動：霸凌、威脅和違禁內容 ' +
    '均不允許。匿名 ≠ 免責 — 違規行為將上報審核。',
  bot_open_btn: '打開 VeylMe',
  notify_answer_btn: '回答',
  bot_invite_text:
    '有人分享了 VeylMe 連結。\n\n' +
    '打開 Mini App 匿名提問：',
  bot_invite_btn: '匿名提問',

  // WORK-027 i18n sweep
  tagline: '匿名問我問題',
  share_ask_action: '提問',
  share_answered_text: '我回答了一個匿名問題 👀',
  err_not_in_telegram: 'Mini App 未在 Telegram 中運行，請重新啟動應用程式。',
  badge_viral_starter: '病毒式起步',
  badge_storyteller: '說故事的人',
  badge_loop_master: '循環大師',
  theme_confession: '告白',
  theme_guesswho: '猜猜我是誰',
  rw_format_named: (name) => `樣式「${name}」`,
  card_label_question: '問題',
  card_label_answer: '回答',
  card_invite_subtitle: '匿名，無需註冊',
  card_code_hint: '在應用程式中輸入代碼',
  share_msg_title: (brand) => `${brand} · 匿名提問`,
  notify_new_question: '🔔 有人向你提了一個匿名問題',
  notify_unanswered_reminder: (n) => `🔔 你有 ${n} 個未回答的問題`,
  notify_ban_permanent: '永久',
  notify_ban_until: (date) => `到 ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ 你在 VeylMe 中被封鎖${untilPhrase}。太多收件者檢舉了你的訊息。\n如果你認為這是誤判，可以在應用程式中提交申訴。`,
  notify_warning_msg: '⚠️ 有多位收件者檢舉了你的訊息。再多一些就會在 VeylMe 中被封鎖。',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: '我的問題',
  my_questions_empty_title: '你還沒有提過問題',
  my_questions_empty_desc: '在別人的信箱裡提個問題——回覆會顯示在這裡。',
  my_questions_loading: '正在查看是否有回覆…',
  my_questions_waiting: '等待回覆',
  my_questions_answer_label: '回覆',
  settings_my_questions: '我的問題',
  ask_sent_find_reply_hint: '之後可以在「我的問題」裡找到回覆。',
  inbox_story_nonpremium_hint: '沒有 Telegram Premium 時，Story 連結不可點擊，所以我們顯示一個代碼——分享到聊天更可靠。',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram 通行證已過期',
  session_expired_desc: 'Telegram 只在啟動時給應用程式發一次通行證，而這一張已經過期了。請重新開啟應用程式——你寫了一半的內容我們已經保存。',
  session_expired_desc_no_storage: '你的 Telegram 通行證已過期，需要重新開啟應用程式。我們沒能保存你輸入的內容——離開前請先複製一下。',
  session_expired_reopen: '重新開啟',
  session_expired_stuck_title: 'Telegram 回傳了同一張舊的通行證',
  session_expired_stuck_desc: '請從機器人選單裡徹底關閉應用程式，然後重新開啟——這樣 Telegram 才會發新的通行證。',
  session_auth_failed_title: '無法確認登入',
  session_auth_failed_desc: 'Telegram 沒有確認你登入了應用程式。請關閉應用程式，再從與機器人的聊天裡重新開啟。',
  session_expired_manual_close: '應用程式無法在這裡自己關閉——請你自己關掉它，再從與機器人的聊天裡重新開啟。',
  session_expiring_soon: 'Telegram 通行證快要過期了。請重新開啟應用程式，以免遺失內容。',
  my_questions_check_failed: '無法查看是否有回覆。請稍後再試。',
  settings_notifications_load_error: '無法載入該設定。',
};
